import { showFatalErrorModal } from '../../../Partials/Header/FatalErrorModal';
import { del, post, put } from '../../../ReactComponents/API';
import { TrackingData } from '../../../Tracking/FacebookConversionApi/TrackingData.csharp';
import { GoogleTagManager } from '../../../Tracking/GoogleTagManager/GoogleTagManager';
import { SetQuantityResult } from '../../Checkout/Summary/LineItemsApi';
import { CartItemViewModel } from '../Item/ViewModels/CartItemViewModel.csharp';
import { handleCartResponseError } from '../Validation/HandleCartResponseError';
import { CartViewModel } from '../ViewModels/CartViewModel.csharp';

export const forbiddenCartOperationError = 'invalidActionPleaseRefresh';
export const unexpectedCartOperationError = 'Unexpected';

export const handleProductCardRequest = async (apiCall: Promise<Response>) => handleRequest(apiCall, 'addToCart.unexpectedError');
export const handleCartRequest = async (apiCall: Promise<Response>) => handleRequest(apiCall, unexpectedCartOperationError);

const handleRequest = async (apiCall: Promise<Response>, defaultError: string): Promise<{ cart: CartViewModel; trackingData: TrackingData }> => {
    return new Promise((resolve, reject) =>
        apiCall
            .then((response) => response.json())
            .then((result) => {
                if (result.validationIssues && result.validationIssues.length > 0) {
                    reject(result);
                }

                resolve(result);
            })
            .catch((error) => {
                if (error?.status !== 401) {
                    showFatalErrorModal();
                }

                if (error?.status === 403) {
                    reject({
                        validationIssues: [{ code: forbiddenCartOperationError, isWarning: true }]
                    });
                } else {
                    reject({ validationIssues: [{ code: defaultError, isWarning: true }] });
                }
            })
    );
};

export const setQuantity = async (
    productCode: string,
    product: CartItemViewModel,
    quantity: number,
    url: string,
    cart: CartViewModel,
    callback: (cart: CartViewModel) => void
): Promise<SetQuantityResult> => {
    if (quantity <= 0) return SetQuantityResult.failed();
    const oldQuantity = cart.items.find((x) => x.code === productCode)!.quantityOrdered;

    const urlWithParams = `${url}?quantity=${quantity}&loginExpected=${!cart.isAnonymous}&cartId=${cart.id}`;
    return handleCartRequest(put(urlWithParams))
        .then((response) => {
            callback(response.cart);
            const item = response.cart.items.find((x) => x.code === productCode);
            if (item) {
                GoogleTagManager.changeQuantity(item, quantity, oldQuantity);
                return SetQuantityResult.succeeded(item.quantityOrdered);
            }

            return SetQuantityResult.failed();
        })
        .catch((issues) => {
            handleCartResponseError(productCode, issues, cart, (cart) => callback(cart));
            return SetQuantityResult.failed();
        });
};

export const removeFromCart = (productCode: string, url: string, cart: CartViewModel, callback: (cart: CartViewModel) => void): Promise<boolean> => {
    return handleCartRequest(del(`${url}?loginExpected=${!cart.isAnonymous}&cartId=${cart.id}`))
        .then((response) => {
            callback(response.cart);
            return true;
        })
        .catch((issues) => {
            handleCartResponseError(productCode, issues, cart, (cart) => callback(cart));
            return false;
        });
};

export const removeItemsFromCart = (productCodes: string[], url: string, cart: CartViewModel, callback: (cart: CartViewModel) => void): Promise<boolean> => {
    return handleCartRequest(post(`${url}?loginExpected=${!cart.isAnonymous}&cartId=${cart.id}`, productCodes))
        .then((response) => {
            callback(response.cart);
            return true;
        })
        .catch((issues) => {
            let cart_ = cart;
            productCodes.forEach((productCode) =>
                handleCartResponseError(productCode, issues, cart, (cart) => {
                    cart_ = cart;
                })
            );
            callback(cart_);
            return false;
        });
};
